export const YouTubeEmbed = ({ url, postId }) => {
  const videoId = url.includes("youtu.be")
    ? url.split("/").pop()
    : new URLSearchParams(new URL(url).search).get("v");
  if (!videoId) return null;
  return (
    <div className="relative w-full aspect-video rounded-2xl overflow-hidden mt-3 max-w-full">
      <iframe
        src={`https://www.youtube.com/embed/${videoId}`}
        className="absolute inset-0 w-full h-full"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        title="YouTube"
      />
    </div>
  );
};
